export default __webpack_public_path__ + "static/media/Pnld_Claro.df7cec23.svg";